<template>
  <div class="container-fluid main">
    <div class="row header">
      <img src="../assets/logo.png"/>
    </div>
    <div class="row body">
      <div class="col-12 card-body">
       <div class="titleRow">
          <h4 class="title">保函真伪查询结果</h4>
        </div>
        <div class="row content">
          <div v-if="effective" class="col-12 rightBox">
            <div class="row" style="margin: 5px;margin-bottom: 20px;">
              <span class="col-6">保函编号：</span>
              <span class="info col-6">{{guaranteeNum}}</span>
            </div>
            <div class="row" style="margin: 5px;margin-bottom: 20px;">
              <span class="col-6">申请单位名称：</span>
              <span class="info col-6">{{employer}}</span>
            </div>
            <div class="row" style="margin: 5px;margin-bottom: 20px;">
              <span class="col-6">受益人名称：</span>
              <span class="info col-6">{{contractor}}</span>
            </div>
            <div class="row" style="margin: 5px;margin-bottom: 20px;">
              <span class="col-6">工程名称：</span>
              <span class="info col-6">{{projectName}}</span>
            </div>
            <div class="row" style="margin: 5px;margin-bottom: 20px;">
              <span class="col-6" style="padding: 0;">担保金额(万元):</span>
              <span class="info col-6">{{guaranteeAmount == '' ? '暂无信息' : parseFloat(guaranteeAmount / 10000.0).toFixed(7)}}</span>
            </div>
            <div class="row" style="margin: 5px;margin-bottom: 20px;" v-if="cutOffDateShow">
              <span class="col-6">担保截止日：</span>
              <span class="info col-6">{{cutOffDate}}</span>
            </div>
            <div class="row" style="margin: 5px;">
              <span class="col-6">担保人：</span>
              <span class="info col-6">{{guarantee}}</span>
            </div>
          </div>
          <div v-else style="width: 100%;text-align: center;margin-top: 100px;font-size: 14px;">
            该保函已到期失效</br>不再显示具体内容
          </div>
        </div>
        <div class="row">
          <div class="col-1"></div>
          <div class="col-10 bottomBox">
            <div class="row" style="margin-top: 10px;padding: 5px;font-weight: 600;">您也可以登录<span style="color: red;">www.zggcbaohan.com </span>通过保函条码及防伪码进行查验</div>
            <div v-if="effective" class="row" style="margin-top: 5px;padding: 5px;">保函条码：<span style="font-weight: 600;">{{barcode}}</span></div>
            <div v-if="effective" class="row" style="padding: 5px;">防伪码：<span style="font-weight: 600;">{{secCode}}</span></div>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="row bottom fixed-bottom">

    </div> -->
  </div>
</template>

<script>
  export default {
    name: 'mbRes',
    data() {
      return {
        res: false,
        barcode: "",
        secCode: "",
        num: "",
        effective: "",
        guaranteeNum: "暂无信息",
        projectName: "暂无信息",
        employer: "暂无信息",
        contractor: "暂无信息",
        guarantee: "暂无信息",
        guaranteeAmount: "暂无信息",
        cutOffDate: "暂无信息",
        cutOffDateShow: true,
      }
    },
    created() {
      this.barcode = this.getUrlKey("barCode");
      this.secCode = this.getUrlKey("secCode");
      this.num = this.getUrlKey("num");
      this.checkRes();
    },
    methods:{
      async checkRes() {
        const { data: res } = await this.$axios.get(
          this.$static.SERVER_URL + "/api/checkRes/getRes",
          {
            params: {
              barCode: this.barcode,
              secCode: this.secCode,
              num: this.num,
              type: "jt"
            }
          }
        );
        if (res.code == 200) {
          if((res.data == null || res.data == undefined || res.data == "") && res.msg == "保函已失效"){
            this.effective = false;
          } else {
            this.guaranteeNum = res.data.guaranteeNum;
            this.projectName = res.data.projectName;
            this.employer = res.data.employer;
            this.contractor = res.data.contractor;
            this.guarantee = res.data.guarantee;
            this.guaranteeAmount = res.data.guaranteeAmount;
            this.cutOffDate = res.data.cutOffDate;
            if(this.cutOffDate == null || this.cutOffDate == undefined || this.cutOffDate == ''){
              this.cutOffDateShow = false;
            } else {
              this.cutOffDateShow = true;
            }
            this.effective = true;
          }
          this.res = true;
        } else {
          this.res = false;
        }
      },
      getUrlKey:function(name){
        return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
      }
    }
  }
</script>

<style scoped>
  .main {
    height: 100%;
    background-color: #F1F1F1;
    font-family: "microsoft yahei";
  }

  .header {
    background-color: rgb(255, 255, 255, 0.5);
    height: 120px;
  }

  .header img {
     height: 100%;
     margin-left: 30px;
  }

  .bottom {
    background-color: white;
    opacity: 0.5;
    height: 40px;
  }

  .body {
    height: 90%;
  }

  .card-body {
    background-color: rgba(255, 255, 255, 0.85);
    height: 100%;
  }

  .titleRow {
    text-align: center;
  }

  .title {
    font-weight: 800;
    color:#007BFF;
  }

  .content {
    height: 75%;
    margin-top: 50px;
  }

  .leftBox {
    height: 100%;
    margin-top: 20%;
  }

  .seq {
    height: 100%;
    margin-top: 2%;
  }

  .rightBox {
    height: 100%;
    /* text-align: left; */
/*    border-left: 1px dashed #CCC;
    padding: 50px; */
  }

  .bottomBox {
    background-color: #F1F1F1;
    opacity: 1;
    border-radius: 3px;
    height: 180px;
  }

  .queryBtn {
    width: 100%;
    background-color: #0069d9;
  }

  .resBox {
    margin-top: 15%;
  }

  .resImg {
    width: 200px;
    margin-bottom: 20px;
  }

  .resMsg {
    font-weight: 600;
    color: #007BFF;
    font-size: 24px;
  }

  .info {
    font-weight: 700;
    text-align: left;
  }

  .bottomBtn{
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/mobileRes.vue